import { useState } from 'react';

export function useSwitch(
    initial: boolean = false,
): [boolean, () => void, () => void, () => void] {
    const [isOn, setIsOn] = useState(initial);

    return [
        isOn,
        () => void setIsOn(true), // on
        () => void setIsOn(false), // off
        () => void setIsOn(!isOn), // toggle
    ];
}
